import { render, staticRenderFns } from "./ShortLink.vue?vue&type=template&id=2132dbd5&"
import script from "./ShortLink.vue?vue&type=script&lang=js&"
export * from "./ShortLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports